<template>
    <div class="dropdown_box" ref="popup">
        <div x-arrow="" class="arrow"></div>
        <div class="dropdown">
            <cl-tag-group
                class="ml10 mr10"
                :list="selectedList"
                :disabled="false"
                @delete="deleteFn"
            />
            <el-input
                style="width: 282px;"
                class="mb10 mt6 ml10"
                size="medium"
                v-model="seachLabel"
                :placeholder="$t('common.请输入')"
                prefix-icon="el-icon-search"
                v-debounce="[seach,`keydown`, 300, 'input']"
            />
            <div
                v-for="item in list"
                :key="item.value"
                class="dropdown-menu"
            >
                <cl-tag :item="item" @click.native="handleAction(item)" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cl-match-label-popup',

    model: {
        prop: 'value',
        event: 'change'
    },

    props: {
        value: {
            type: Array,
            default: () => []
        },
        list: {
            type: Array,
            default: () => []
        },
        loadData: {
            type: Function,
            default: () => new Function()
        },
        color: {
            type: String,
            default: '#81818A'
        },
        // 标签icon图标
        tagIcon: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            seachLabel: '', // 搜索的标签名
            selectedList: this.value || [], // 选择的标签列表
        }
    },
    // computed: {
    //     // 当前标签图标
    //     currentIcon () {
    //         let icon = this.tagIcon;
    //         if (!icon) {
    //             icon = this.selectedList.length ? 'tu_schedule_tag_active' : 'tu_schedule_tag'
    //         }
    //         return icon;
    //     }
    // },
    watch: {
        value (val) {
            this.selectedList = val;
        }
    },
    created () {
        console.log(this.list)
        this.$nextTick(()=>{
            //元素点击关闭弹窗
            document.addEventListener('click', (e) => {
                if(this.$refs.popup && !this.$refs.popup.contains(e.target)){
                    this.$emit('closeLabel','ok')
                }
            })
        })
    },
    methods: {
        // 删除选中
        deleteFn (item) {
            let i = this.selectedList.findIndex(el => el.name === item.name);
            this.selectedList.splice(i, 1);
            this.$emit('change', this.selectedList);
        },
        // 点击某一项
        handleAction (row) {
            console.log('row::: ', row)
            let i = this.selectedList.findIndex(el => el.name === row.name);
            if (i === -1) this.selectedList.push(row);
            this.$emit('change', this.selectedList);
        },
        // 搜索标签
        seach () {
            this.loadData(this.seachLabel)
        },
        // 清空搜索标签
        resetSearch() {
            this.seachLabel = ''
        },
    }
}
</script>
<style lang="scss" scoped>
.dropdown_box {
    position: relative;
    .arrow{
        position: absolute;
        top: -5px;
        right: 10px;
        display: block;
        width: 0;
        height: 0;
        border-width: 6px;
        border-color: transparent;
        border-style: solid;
        border-top-width: 0;
        border-bottom-color: #FFFFFF;
        filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
    }
}
.dropdown {
    padding: 20px 10px;
    box-sizing: border-box;
    width: 330px;
    background-color: #fff;
    max-height: 400px;
    overflow: hidden auto;
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    box-shadow: 0px 6px 16px rgba(129, 129, 138, 0.1);
    .dropdown-menu {
        padding: 8px 16px;
        line-height: 1;
        border-radius: $base-border-radius-mini;
    }
    .dropdown-menu:not(.is-disabled):hover {
        background-color: #f2f2f3;
    }
    .dropdown-menu:focus {
        background-color: transparent;
    }
}
</style>